import { parsePhoneNumberWithError, ParseError } from "libphonenumber-js/min";

export function phoneNumberFilter() {
    return (value: string, params?: any) => {
        try {
            const phoneNumber = parsePhoneNumberWithError(value);
            return phoneNumber.isValid() ? phoneNumber.format('INTERNATIONAL') : value;
        } catch (error) {
            if (error instanceof ParseError) {
                console.log(error.message)
            }
            return value;
        }
    }
}
